import ReactDOM from 'react-dom/client';
import './styles/index.css';
import { App } from './App';
import React from 'react';

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
